import forge from "node-forge";

export const decode64 = (base64: string) => {
    return forge.util.decode64(base64);
};
